// Search for "Specialaftale" to find specialaftale-stuff


import angular from 'angular';
import {
  result
} from 'lodash';

import '../../../services/product';
import '../products-list-item';
import '../../../services/datastorage';
import '../../../services/media';


angular.module('folkeuni').component('productsListFavorite', {
  bindings: {
    categoryUrl: '@',
    currentProgramUrl: '@',
    filterHeadline: '@',
    categoryPickerLabel: '@',
    timePickerLabel: '@',
    filterText: '@',
    siteId: '<',
    areaId: '<',
    filterOnly: '<',
    programUrl: '@'
  },
  templateUrl: '/shop-dist/templates/products-list.html?c=' + window.cacheBurst,
  transclude: true,
  controller: function (DataStorage, Media, Product, $window, $document, $element, $timeout, $rootScope) {
    var $ctrl = this;
    $ctrl.products = [];
    $ctrl.productsState = {};
    $ctrl.hideFilters = true;
    $ctrl.hideProductList = false;
    $ctrl.preSelectedCategory = null;

    $ctrl.getProducts = () => {
      return new Promise((resolve) => {
        const favorites = JSON.parse(localStorage.getItem("favoriteList"));
        let productIds = favorites ? favorites.map((product) => product.id) : [];
        
        $ctrl.products = $ctrl.products || [];

        if (productIds.length === 0) {
          $ctrl.loading = false;
          resolve();
        } else {
           Product.getProductsById($ctrl.siteId, productIds, "crop=48:25").then(
               function (products) {
                   $ctrl.products = $ctrl.products.concat(products);
                   $ctrl.loading = false;
                   resolve();
               },
               function (errorResponse) {
                   console.error("Error", errorResponse);
                   resolve();
               }
           );
        }
      })
    }

    $ctrl.$onInit = async function () {
      await $ctrl.getProducts();
      goToLastVisitedProduct();

      function goToLastVisitedProduct() {
        if (typeof (Storage) !== "undefined") {
          DataStorage.get("lastVisitedProduct").then(function (lastVisitedProductIndex) {
            var productInArray = $ctrl.products.map((item) => {
              return item.id
            }).indexOf(lastVisitedProductIndex);

            $timeout(function () {
              if (productInArray > -1) {
                $document.scrollToElement($element.find('products-list-item')[productInArray], 1);
                DataStorage.set('lastVisitedProduct', '');
              } else {
                $window.scrollTo(0, 0);
              }
            }, 150);
          }, function (message) { });
        }
      }
    }
  }
});